function Index() {
  return import(/* webpackChunkName: "index" */ '@/pages/app/index.vue')
}
function DianpeiIndex() {
  return import(
    /* webpackChunkName: "dianpei-index" */ '@/pages/app/dianpei/index.vue'
  )
}
function FangxiaoIndex() {
  return import(
    /* webpackChunkName: "fangxiao-index" */ '@/pages/app/fangxiao/index.vue'
  )
}
function HhgIndex() {
  return import(/* webpackChunkName: "hhg-index" */ '@/pages/app/hhg/index.vue')
}
function JiacaiIndex() {
  return import(
    /* webpackChunkName: "jiacai-index" */ '@/pages/app/jiacai/index.vue'
  )
}
function JunengIndex() {
  return import(
    /* webpackChunkName: "juneng-index" */ '@/pages/app/juneng/index.vue'
  )
}
function LhproIndex() {
  return import(
    /* webpackChunkName: "lhpro-index" */ '@/pages/app/lhpro/index.vue'
  )
}
function LightIndex() {
  return import(
    /* webpackChunkName: "light-index" */ '@/pages/app/light/index.vue'
  )
}
function LyxejyIndex() {
  return import(
    /* webpackChunkName: "lyxejy-index" */ '@/pages/app/lyxejy/index.vue'
  )
}
function PartyIndex() {
  return import(
    /* webpackChunkName: "party-index" */ '@/pages/app/party/index.vue'
  )
}
function RunjiPosterIndex() {
  return import(
    /* webpackChunkName: "runji-poster-index" */ '@/pages/app/runji-poster/index.vue'
  )
}
function SolestageIndex() {
  return import(
    /* webpackChunkName: "solestage-index" */ '@/pages/app/solestage/index.vue'
  )
}
function SolestagepdfIndex() {
  return import(
    /* webpackChunkName: "solestagepdf-index" */ '@/pages/app/solestagepdf/index.vue'
  )
}
function XpdIndex() {
  return import(/* webpackChunkName: "xpd-index" */ '@/pages/app/xpd/index.vue')
}
function ZaizaiIndex() {
  return import(
    /* webpackChunkName: "zaizai-index" */ '@/pages/app/zaizai/index.vue'
  )
}
function ZhituoIndex() {
  return import(
    /* webpackChunkName: "zhituo-index" */ '@/pages/app/zhituo/index.vue'
  )
}
function ZhonghuiIndex() {
  return import(
    /* webpackChunkName: "zhonghui-index" */ '@/pages/app/zhonghui/index.vue'
  )
}
function JiacaiDownload() {
  return import(
    /* webpackChunkName: "jiacai-download" */ '@/pages/app/jiacai/download.vue'
  )
}
function LightPosters() {
  return import(
    /* webpackChunkName: "light-posters" */ '@/pages/app/light/posters.vue'
  )
}
function LyxejyNotice() {
  return import(
    /* webpackChunkName: "lyxejy-notice" */ '@/pages/app/lyxejy/notice.vue'
  )
}
function SolestageDownload() {
  return import(
    /* webpackChunkName: "solestage-download" */ '@/pages/app/solestage/download.vue'
  )
}
function SolestageForgetPassword() {
  return import(
    /* webpackChunkName: "solestage-forgetPassword" */ '@/pages/app/solestage/forgetPassword.vue'
  )
}
function SolestageProductDetail() {
  return import(
    /* webpackChunkName: "solestage-productDetail" */ '@/pages/app/solestage/productDetail.vue'
  )
}
function SolestageSignup() {
  return import(
    /* webpackChunkName: "solestage-signup" */ '@/pages/app/solestage/signup.vue'
  )
}
function SolestageLiveIndex() {
  return import(
    /* webpackChunkName: "solestage-live-index" */ '@/pages/app/solestage/live/index.vue'
  )
}
function TianjuStore() {
  return import(
    /* webpackChunkName: "tianju-store" */ '@/pages/app/tianju/store.vue'
  )
}
function TiannengStore() {
  return import(
    /* webpackChunkName: "tianneng-store" */ '@/pages/app/tianneng/store.vue'
  )
}
function TiannengTest() {
  return import(
    /* webpackChunkName: "tianneng-test" */ '@/pages/app/tianneng/test.vue'
  )
}
function ZhituoShare() {
  return import(
    /* webpackChunkName: "zhituo-share" */ '@/pages/app/zhituo/share.vue'
  )
}
function ZhonghuiImage() {
  return import(
    /* webpackChunkName: "zhonghui-image" */ '@/pages/app/zhonghui/image.vue'
  )
}
function ZhonghuiPosters() {
  return import(
    /* webpackChunkName: "zhonghui-posters" */ '@/pages/app/zhonghui/posters.vue'
  )
}
function SolestageComponentHeaderTip() {
  return import(
    /* webpackChunkName: "solestage-component-headerTip" */ '@/pages/app/solestage/component/headerTip.vue'
  )
}
function SolestageComponentPageError() {
  return import(
    /* webpackChunkName: "solestage-component-page-error" */ '@/pages/app/solestage/component/page-error.vue'
  )
}
function SolestageComponentPageLoading() {
  return import(
    /* webpackChunkName: "solestage-component-page-loading" */ '@/pages/app/solestage/component/page-loading.vue'
  )
}
function SolestageLiveEnd() {
  return import(
    /* webpackChunkName: "solestage-live-end" */ '@/pages/app/solestage/live/end.vue'
  )
}
function SolestageLiveRoom() {
  return import(
    /* webpackChunkName: "solestage-live-room" */ '@/pages/app/solestage/live/room.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: Index
  },
  {
    name: 'dianpei-index',
    path: 'dianpei',
    component: DianpeiIndex
  },
  {
    name: 'fangxiao-index',
    path: 'fangxiao',
    component: FangxiaoIndex
  },
  {
    name: 'hhg-index',
    path: 'hhg',
    component: HhgIndex
  },
  {
    name: 'jiacai-index',
    path: 'jiacai',
    component: JiacaiIndex
  },
  {
    name: 'juneng-index',
    path: 'juneng',
    component: JunengIndex
  },
  {
    name: 'lhpro-index',
    path: 'lhpro',
    component: LhproIndex
  },
  {
    name: 'light-index',
    path: 'light',
    component: LightIndex
  },
  {
    name: 'lyxejy-index',
    path: 'lyxejy',
    component: LyxejyIndex
  },
  {
    name: 'party-index',
    path: 'party',
    component: PartyIndex
  },
  {
    name: 'runji-poster-index',
    path: 'runji-poster',
    component: RunjiPosterIndex
  },
  {
    name: 'solestage-index',
    path: 'solestage',
    component: SolestageIndex
  },
  {
    name: 'solestagepdf-index',
    path: 'solestagepdf',
    component: SolestagepdfIndex
  },
  {
    name: 'xpd-index',
    path: 'xpd',
    component: XpdIndex
  },
  {
    name: 'zaizai-index',
    path: 'zaizai',
    component: ZaizaiIndex
  },
  {
    name: 'zhituo-index',
    path: 'zhituo',
    component: ZhituoIndex
  },
  {
    name: 'zhonghui-index',
    path: 'zhonghui',
    component: ZhonghuiIndex
  },
  {
    name: 'jiacai-download',
    path: 'jiacai/download',
    component: JiacaiDownload
  },
  {
    name: 'light-posters',
    path: 'light/posters',
    component: LightPosters
  },
  {
    name: 'lyxejy-notice',
    path: 'lyxejy/notice',
    component: LyxejyNotice
  },
  {
    name: 'solestage-download',
    path: 'solestage/download',
    component: SolestageDownload
  },
  {
    name: 'solestage-forgetPassword',
    path: 'solestage/forgetPassword',
    component: SolestageForgetPassword
  },
  {
    name: 'solestage-productDetail',
    path: 'solestage/productDetail',
    component: SolestageProductDetail
  },
  {
    name: 'solestage-signup',
    path: 'solestage/signup',
    component: SolestageSignup
  },
  {
    name: 'solestage-live-index',
    path: 'solestage/live',
    component: SolestageLiveIndex
  },
  {
    name: 'tianju-store',
    path: 'tianju/store',
    component: TianjuStore
  },
  {
    name: 'tianneng-store',
    path: 'tianneng/store',
    component: TiannengStore
  },
  {
    name: 'tianneng-test',
    path: 'tianneng/test',
    component: TiannengTest
  },
  {
    name: 'zhituo-share',
    path: 'zhituo/share',
    component: ZhituoShare
  },
  {
    name: 'zhonghui-image',
    path: 'zhonghui/image',
    component: ZhonghuiImage
  },
  {
    name: 'zhonghui-posters',
    path: 'zhonghui/posters',
    component: ZhonghuiPosters
  },
  {
    name: 'solestage-component-headerTip',
    path: 'solestage/component/headerTip',
    component: SolestageComponentHeaderTip
  },
  {
    name: 'solestage-component-page-error',
    path: 'solestage/component/page-error',
    component: SolestageComponentPageError
  },
  {
    name: 'solestage-component-page-loading',
    path: 'solestage/component/page-loading',
    component: SolestageComponentPageLoading
  },
  {
    name: 'solestage-live-end',
    path: 'solestage/live/end',
    component: SolestageLiveEnd
  },
  {
    name: 'solestage-live-room',
    path: 'solestage/live/room',
    component: SolestageLiveRoom
  }
]
